<template>
	<div class="ss-content index-content">
		<ss-right-menu />
	
		<!-- 轮播图 -->
		<section class="swiper-box" v-if="imgList.length">
			<slick ref="slick" :options="slickOptions">
				<div class="swiper-silde" v-for="(item, index) in imgList" :key="item.id">
					<!-- <img :src="item.attrs | imgUrl('bannerPc')"/> -->
					<div class="swiper-silde__image" @click.stop="lbtClick(item)" @mousedown="handleMousedown" @mouseup="handleMouseup" :style="{backgroundImage: 'url(' + $options.filters['imgUrl'](item.attrs, 'bannerPc') + ')'}"></div>
				</div>
				<div class="swiper-pagination" slot="pagination"></div>
			</slick>
		</section>
		<!-- 文化资讯 -->
		<section class="whzx-container ss-container">
			<div class=" whzx-left">
				<div class="whzx-left__top">
					<div class="page-section-box">
						<p class="page-section__title">文化资讯</p>
						<p class="page-section__enTitle">Performance<br />Center</p>
					</div>
					<router-link :to="{name: 'culturalInfo'}" class="page-section__more">more>></router-link>
				</div>
				<div class="whzx-left__bottom">
					<img :src="whzxPic | imgUrl" class="whzx-left__bottom_image poster-image" />
				</div>
			</div>
			<div class="whzx-right">
				<div class="whzx-menu">
					<div class="whzx-menu__item" :class="{'whzx-menu__item_active': whzxIndex === index}" @click="changeWhzx(index)" v-for="(item, index) in whzxMenus" :key="item.value">{{item.label}}</div>
				</div>
				<div class="whzx-info">
					<router-link class="whzx-item clearfix" v-for="(item, index) in whzxData_" :key="index" :to="'/cultureAround/info/' + item.id">
						<div class="whzx-item__time">
							<div class="whzx-item__time_big">{{item.releaseTimestamp | time('d')}}</div>
							<div class="whzx-item__time_small">{{item.releaseTimestamp | time('y.m')}}</div>
						</div>
						<div class="whzx-item__right">
							<div class="whzx-item__title">{{item.title}}</div>
							<div class="whzx-item__desc">{{item.contentExt && item.contentExt.description}}</div>
						</div>
					</router-link>
				</div>
			</div>
		</section>
		<!-- 广告 -->
		<router-link class="ad-container ss-container" to="volunteerHome">
			<div class="ad-container__content">
				<div class="ad-container__text">
					<span>公共文化</span>
					<span>共建共享</span>
				</div>
				<div class="btn-box">点击进入</div>
			</div>
		</router-link>
		<!-- 活动报名 -->
		<section class="activity-container ss-container">
			<div class="flex">
				<div class="activity-left clearfix">
					<div class="activity-left__item" v-for="(item, index) in activityData" :key="index">
						<div class="activity-left-box">
							<div class="activity-left__top">
								<img class="activity-left__top_image poster-image" :src="item.attrs | imgUrl" />
								<div class="activity-left__top_mask"></div>
							</div>
							<div class="activity-left__bottom">
								<p class="activity-left__title">{{item.title}}</p>
								<div class="activity-left__eyes">
									<img class="activity-left__eyes_image" src="~@/assets/img/index/eyes.png" />
									<span class="activity-left__eyes_text">{{item.views}}</span>
								</div>
								<p class="activity-left__text" v-if="item.attrs.startDate">活动时间:{{item.attrs.startDate.substring(0,10)}} ~ {{item.attrs.endDate.substring(0,10)}}</p>
								<!-- <p class="activity-left__text">活动时间:{{item.attrs.startDate.substring(0,10)}} ~ {{item.attrs.endDate.substring(0,10)}}</p> -->
<!--								<p class="activity-left__time">{{item.attrs.startDate.substring(0,10)}} ~ {{item.attrs.endDate.substring(0,10)}}</p>-->
								<button class="activity-left__btn" @click="goActivityDetail(item.id)" :class="{'btn-gray': item.activityStatus === 4, 'btn-error': item.activityStatus === 3, 'btn-success': item.activityStatus === 2, 'btn-primary': item.activityStatus === 1}">
									{{item.activityStatus === 4 ? '已结束' : (item.activityStatus === 3 ? '报名已满' : (item.activityStatus === 2 ? '直接前往' : '立即预约'))}}
								</button>
								<!-- <button class="activity-left__btn" @click="goActivityDetail(item.id)">查看详情</button> -->
							</div>
						</div>
					</div>
				</div>
				<div class="activity-right">
					<router-link :to="{name: 'culturalActivity'}"  class="activity-right__box">
						<img src="~@/assets/img/index/hdbm-right.png" class="hdbm-right_image" />
						<!-- <p class="activity-right__title">活动报名</p>
						<p class="activity-right__enTitle">Performance<br/>Center</p> -->
					</router-link>
					<!-- <router-link :to="{name: 'culturalActivity'}" class="activity-right__more">more →</router-link> -->
				</div>
			</div>
		</section>
		<!-- 精彩E家 -->
		<section class="train-container ss-container" v-if="jcejList.length">
			<p class="category__title">精彩E家</p>
			<p class="category__enTitle">
				Wonderful E Home
				<router-link class="fr" :to="{name: 'behTrain'}">more</router-link>
			</p>
			<ssTrainList :value="jcejList" class="train-list" detailPath="/brilliantEHome/train/"  />
		</section>
		<!-- 大兴非遗 -->
		<section class="dxfy-container" v-if="wonderfulTrainList.length">
			<div class="dxfy-intro ss-container clearfix">
				<div class="dxfy-intro__left">
					<div class="dxfy-intro__left_top">
						<router-link :to="{name: 'lchIntro'}">
							<img src="~@/assets/img/index/dxfy-left.png" class="dxfy-intro__left_image" />
						</router-link>
						<!-- <div class="page-section-box">
							<p class="page-section__title">大兴非遗</p>
							<p class="page-section__enTitle">Intangible Cultural<br />Heritage Center</p>
						</div>
						<router-link :to="{name: 'lchIntro'}" class="page-section__more">more>></router-link>
						<img src="~@/assets/img/index/dxfy-left.png" class="dxfy-intro__left_image" /> -->
					</div>
					<div class="dxfy-intro__left_bottom">
						<div class="dxfy-intro__left_time">{{wonderfulTrainListTop_.releaseTimestamp | time}}</div>
						<div class="dxfy-intro__left_title">{{wonderfulTrainListTop_.title}}</div>
						<div class="dxfy-intro__left_desc">{{wonderfulTrainListTop_.contentExt && wonderfulTrainListTop_.contentExt.description}}</div>
						<div class="dxfy-intro__left_btn" @click="goDxfyDetail(wonderfulTrainListTop_.id)">查看详情</div>
					</div>
				</div>
				<img class="dxfy-intro__right poster-image" :src="dxfyPic | imgUrl" />
			</div>
			<div class="ss-container">
				<div class="dxfy-list clearfix">
					<div class="dxfy-item clearfix" @click="goDxfyDetail(item.id)" v-for="(item, index) in wonderfulTrainListBottom_" :key="index">
						<div class="dxfy-item__img">
							<img :src="item.attrs |imgUrl" />
						</div>
						<div class="dxfy-item__content">
							<p class="dxfy-item__title">{{item.title}}</p>
							<p class="dxfy-item__time">{{item.releaseTimestamp | time}}</p>
							<div class="dxfy-item-tools clearfix">
								<div class="dxfy-item-tools__item">
									<img src="~@/assets/img/index/ck.png" />
									{{item.views}}
								</div>
								<div class="dxfy-item-tools__item">
									<img src="~@/assets/img/index/zan.png" />
									{{item.ups}}
								</div>
								<div class="dxfy-item-tools__item">
									<img src="~@/assets/img/index/pl.png" />
									{{item.comments}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		
		<!-- 热门场馆 -->
		<section class="venue-container ss-container">
			<p class="category__title">热门场馆</p>
			<p class="category__enTitle">
				Exhibition Center
				<router-link class="fr" :to="{name: 'culturalMapIndex'}">more</router-link>
			</p>
			<div class="venue-list clearfix">
				<router-link class="venue-item" v-for="(item, index) in hotCG" :key="index" :to="'/culturalMap/detail/' + item.id + '?level=' + item.attrs.level + '&integral=' + item.attrs.integral">
					<img :src="BASE_URL() + (item.attrs && item.attrs.listPic)" class="venue-item__image" />
					<p class="venue-title">{{item.title}}</p>
					<p class="venue-address">
						<img src="~@/assets/img/index/map.png" class="fr" @click="openLocation(item.title, item.attrs)" />
						{{item.attrs && item.attrs.address}}
					</p>
				</router-link>
			</div>
		</section>
		<!-- 资讯飘窗 -->
		<div 
			class="pc-popup" 
			v-if="pcList && !pcListClosed && pcList.attrs && pcList.attrs.listPic"
			@mouseover="pcPopupMouseover"
			@mouseout="pcPopupMouseout"
			:style="{ top: pcPopupTop + 'px', left: pcPopupLeft + 'px' }"
		>
			<div class="pc-popup__close" @click.stop="closePCPopup">×</div>
			<img 
				class="pc-popup__image" 
				:src="pcList.attrs.listPic | imgUrl" 
				@click="goToPCDetail(pcList.id)"
				@load="pcPopupImageLoad"
				:alt="pcList.title" 
			/>
		</div>
	</div>
</template>

<script>
	import Slick from 'vue-slick'
    import 'slick-carousel/slick/slick.css'
    import 'slick-carousel/slick/slick-theme.css'
	import ssRightMenu from '@/components/ss-right-menu/ss-right-menu.vue'
	import ssTrainList from '@/components/ss-train-list/ss-train-list.vue'
	import { openLocation } from '@/utils'
  import {BASE_URL} from "@/config";
	export default {
		name: "index",
		components: {
			Slick, ssTrainList, ssRightMenu
		},
		data() {
			return {
				whzxIndex: -1,
				whzxMenus: [{
					value: 'qwxx',
					label: '群文信息'
				},{
					value: 'tzgg',
					label: '通知公告'
				},{
					value: 'whzc',
					label: '文化政策'
				},{
					value: 'ycsf',
					label: '迎春送福'
				}],
				whzxData: [],
				slickOptions: {
					infinite: true,
					arrows: false,
					dots: true,
					autoplay: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					autoplaySpeed: 5000,
					// draggable: true,
					touchMove: true,
				},
				imgList: [],
				// 资讯飘窗
				pcList: null,
				pcListClosed: false, // 飘窗是否已关闭
				// 飘窗移动相关
				pcPopupTimer: null, // 飘窗移动定时器
				pcPopupStepX: 1, // X轴移动步长
				pcPopupStepY: 1, // Y轴移动步长
				pcPopupTop: 0, // 飘窗top位置
				pcPopupLeft: 0, // 飘窗left位置
				pcPopupMaxTop: 0, // 飘窗最大top值
				pcPopupMaxLeft: 0, // 飘窗最大left值
				pcPopupWidth: 300, // 飘窗宽度
				pcPopupHeight: 400, // 飘窗高度
				pcPopupResizeHandler: null, // 窗口大小改变事件处理器
				wonderfulTrainList: [],
				jcejList: [],
				hotCG: [],
				activityData: [],
				bigPicParams: {
					whzxPic: 'sbwhwhzx',
					dxfyPic: 'dxfy'
				},
				whzxPic: '',
				dxfyPic: '',
				mousedownNum: '',
				canClick: true,
			}
		},
		computed: {
			whzxData_() {
				return this.whzxData[this.whzxIndex] || []
			},
			wonderfulTrainListTop_() {
				return (this.wonderfulTrainList.slice(0, 1) || [])[0] || {};
			},
			wonderfulTrainListBottom_() {
				return this.wonderfulTrainList.slice(1, 5) || [];
			}
		},
		created() {
			this.getBanner();
			this.getPC();
			this.changeWhzx(0);
			this.indexActivityPage();
			this.getBigPic();
			this.getjcej();
			this.getWonderfulTrain();
			this.getHotCG();
		},
		mounted() {
			// 监听窗口大小改变
			this.pcPopupOnResize();
		},
		beforeDestroy() {
			// 清除飘窗定时器
			if(this.pcPopupTimer) {
				clearInterval(this.pcPopupTimer);
				this.pcPopupTimer = null;
			}
			// 移除窗口大小改变监听
			if(this.pcPopupResizeHandler) {
				window.removeEventListener('resize', this.pcPopupResizeHandler);
			}
		},
		methods: {
      BASE_URL() {
        return BASE_URL
      },
			/** 仅允许 http/https 的绝对地址，避免 javascript: 等危险协议 */
			isValidThirdPartyLink(raw) {
				if (raw == null || typeof raw !== 'string') return false;
				const s = raw.trim();
				if (!s) return false;
				try {
					const u = new URL(s);
					return u.protocol === 'http:' || u.protocol === 'https:';
				} catch {
					return false;
				}
			},
			lbtClick(item) {
				if (!this.canClick) return;
				const thirdLink = item && item.attrs && item.attrs.thirdLink;
				if (this.isValidThirdPartyLink(thirdLink)) {
					window.open(thirdLink.trim(), '_blank', 'noopener,noreferrer');
					return;
				}
				this.$searchJump(item.id, this);
			},
      handleMousedown(e) {
        this.mousedownNum = e.clientX
      },
      handleMouseup(e) {
        if(Math.abs(e.clientX - this.mousedownNum) > 10) {
          this.canClick = false
        } else {
          this.canClick = true
        }
      },
			async getBigPic() {
				let promiseArr = [];
				let keys = Object.keys(this.bigPicParams)
				keys.forEach(key => {
					promiseArr.push(this.$http('channelIntro', {
						channelPath: this.bigPicParams[key]
					}));
				})
				let res = await Promise.all(promiseArr);
				keys.forEach((key, index) => {
					this[key] = res[index].data.listPic;
				})
			},
			async getjcej(){
				let res = await this.$http('resourcePage', {
					page: 1,
					size: 8,
					channelPaths: 'jcpxsy,jcpxsf,jcpxms,jcpxlq,jcpxsl,jcpxfy,jcpxqt'
				})
				if(res.code === 1){
					let { content = [] } = res.data;
					this.jcejList = content;
				}
			},
			goDxfyDetail(id) {
				this.$router.push({
					path: '/lch/intro/' + id
				})
			},
			goActivityDetail(id) {
				this.$router.push({
					path: '/cultureAround/activity/' + id
				})
			},
			openLocation(title, { latitude, longitude, address }) {
				openLocation(latitude, longitude, title, address);
			},
			init() {
				this.searchList = uni.getStorageSync('searchStorage') || [];
				this.$http('searchWordList').then(res => {
					if(res.code === 1){
						this.hotList = res.data;
					}
				})
			},
			async indexActivityPage() {
				let res = await this.$http('indexActivityPage', {
					size: 4,
					page: 1,
          channelPaths: 'px,zl,bs,yc,tdzm,qt'
				});
				if(res.code === 1){
					let { content = [] } = res.data;
					this.activityData = content;
				}
			},
			async changeWhzx(index) {
				if(this.whzxIndex === index) return ;
				this.whzxIndex = index;
				let res = await this.$http('resourcePage', {
					page: 1,
					size: 4,
					channelPaths: this.whzxMenus[index].value
				})
				if(res.code === 1){
					this.$set(this.whzxData, index, res.data.content || []);
				}
			},
			async getHotCG() {
				let res = await this.$http('resourcePage', {
					page: 1,
					size: 6,
					channelPaths: 'zgxx,fglb,jcwhz,qtggwhsslb',
					orderBy: 29
				})
				if(res.code === 1){
					this.hotCG = res.data.content;
				}
			},
			jumpByName(name) {
				this.$Router.push({
					name: name
				})
			},
			goNotice(id) {
				this.$refs.infoRef.goDetail(id, {title: '公告详情'});
			},
			// 获取banner
			async getBanner() {
				const params = {};
            	params.releaseTarget = 1;
				let res = await this.$http('indexLBT',params);
				if(res.code === 1) {
					this.imgList = res.data;
					this.$nextTick(() => {
						setTimeout(() => {
							this.$refs.slick.reSlick();
						}, 100)
					})
				}
			},
			// 获取飘窗
			async getPC() {
				let res = await this.$http('indexPC', {
					channelPaths: 'sytc',
				});
				if(res.code === 1) {
					if(res.data.length) {
						this.pcList = res.data[0];
						// 初始化飘窗移动
						this.$nextTick(() => {
							this.pcPopupInit();
						});
					}
				}
			},
			// 初始化飘窗移动
			pcPopupInit() {
				// 获取飘窗元素的实际尺寸
				const popupElement = this.$el.querySelector('.pc-popup');
				if(popupElement) {
					const rect = popupElement.getBoundingClientRect();
					this.pcPopupWidth = rect.width || 300;
					this.pcPopupHeight = rect.height || 400;
				}
				// 设置最大top和left值：可视区域宽高 - 飘窗宽高 - 边距
				this.pcPopupMaxTop = document.documentElement.clientHeight - this.pcPopupHeight - 5;
				this.pcPopupMaxLeft = document.documentElement.clientWidth - this.pcPopupWidth - 5;
				// 设置初始位置为左上角
				this.pcPopupTop = 0;
				this.pcPopupLeft = 0;
				// 清除之前的定时器
				if(this.pcPopupTimer) {
					clearInterval(this.pcPopupTimer);
				}
				// 创建定时器开始移动
				this.pcPopupTimer = setInterval(() => {
					this.pcPopupMove();
				}, 20);
			},
			// 图片加载完成后重新初始化（获取实际尺寸）
			pcPopupImageLoad() {
				this.$nextTick(() => {
					this.pcPopupInit();
				});
			},
			// 飘窗移动函数
			pcPopupMove() {
				// 碰撞检测：当到达边界时改变方向
				if(this.pcPopupTop >= this.pcPopupMaxTop || this.pcPopupTop < 0) {
					this.pcPopupStepY = -this.pcPopupStepY;
				}
				if(this.pcPopupLeft >= this.pcPopupMaxLeft || this.pcPopupLeft < 0) {
					this.pcPopupStepX = -this.pcPopupStepX;
				}
				// 更新位置
				this.pcPopupTop += this.pcPopupStepY;
				this.pcPopupLeft += this.pcPopupStepX;
			},
			// 鼠标悬停时停止移动
			pcPopupMouseover() {
				if(this.pcPopupTimer) {
					clearInterval(this.pcPopupTimer);
					this.pcPopupTimer = null;
				}
			},
			// 鼠标离开时恢复移动
			pcPopupMouseout() {
				if(this.pcPopupTimer) {
					clearInterval(this.pcPopupTimer);
				}
				this.pcPopupTimer = setInterval(() => {
					this.pcPopupMove();
				}, 20);
			},
			// 窗口大小改变时重置飘窗
			pcPopupOnResize() {
				const that = this;
				this.pcPopupResizeHandler = function() {
					if(that.pcList && !that.pcListClosed && that.pcList.attrs && that.pcList.attrs.listPic) {
						that.pcPopupInit();
					}
				};
				window.addEventListener('resize', this.pcPopupResizeHandler);
			},
			// 关闭飘窗
			closePCPopup() {
				if(this.pcPopupTimer) {
					clearInterval(this.pcPopupTimer);
					this.pcPopupTimer = null;
				}
				this.pcListClosed = true;
			},
			// 跳转到飘窗详情页
			goToPCDetail(id) {
				if(id) {
					this.$router.push({
						path: '/cultureAround/info/' + id
					});
				}
			},
			// 大兴非遗
			async getWonderfulTrain() {
				let res = await this.$http('indexWonderfulTrain');
				if(res.code === 1){
					this.wonderfulTrainList = res.data;
				}
			},
			searchClick() {
				this.$Router.push({
					name: 'search'
				})
			},
			onSlideChangeStart (currentPage) {
				console.log('onSlideChangeStart', currentPage);
			},
			onSlideChangeEnd (currentPage) {
				console.log('onSlideChangeEnd', currentPage);
			},
      formatDate(date){
        return date.substring(0,10)
      }
		}
	}
</script>

<style lang="scss">
	.index-content {
		background-color: #fff;
		padding-bottom: 70px;
		width: 100%;
		overflow: hidden;
		.venue-container{
			margin-top: 70px;
			.venue-list{
				padding-right: 34px;
				.venue-item{
					margin-top: 30px;
					width: 50%;
					float: left;
					padding: 66px 35px 0 180px;
					height: 200px;
					border:1px solid rgba(209,209,209,1);
					border-radius:5px;
					position: relative;
					cursor: pointer;
					&:nth-of-type(2n){
						float: right;
						margin-right: -34px;
					}
					.venue-item__image{
						@include abs(34px, null, null, 34px);
						width: 130px;
						height: 130px;
					}
					&:hover{
						.venue-title{
							color: #0260FC;
						}
					}
				}
				.venue-title{
					font-size: 26px;
					line-height: 18px;
					color: #202a30;
				}
				.venue-address{
					margin-top: 23px;
					font-size: 18px;
					line-height: 22px;
					color: #777777;
				}
			}
		}
		.dxfy-container{
			margin: 0 auto;
			.dxfy-list{
				padding-right: 70px;
				.dxfy-item{
					margin-top: 58px;
					width: 50%;
					float: left;
					cursor: pointer;
					&:nth-of-type(2n){
						float: right;
						margin-right: -70px;
					}
					&:hover{
						.dxfy-item__title{
							color: #0260FC;
						}
					}
				}
				.dxfy-item__title{
					font-size:20px;
					font-weight:400;
					color:rgba(32,41,47,1);
					line-height:28px;
				}
				.dxfy-item__time{
					margin-top: 20px;
					font-size:14px;
					font-family:Source Han Sans CN;
					font-weight:400;
					color:rgba(153,153,153,1);
					line-height:28px;
				}
				.dxfy-item__content{
					padding-left: 22px;
					float: right;
					width: 280px;
					height: 197px;
					position: relative;
				}
				.dxfy-item-tools{
					@include abs(null, 0, 0, 22px);
					.dxfy-item-tools__item{
						float: left;
						width: 33.33333333%;
						font-size: 16px;
						line-height: 18px;
						color: #666;
						img {
							display: inline-block;
							height: 15px;
							vertical-align: middle;
						}
					}
				}
				.dxfy-item__img{
					width: 285px;
					float: left;
					height: 197px;
					img{
						width: 100%;
						height: 100%;
						display: block;
					}
				}
			}
			.dxfy-intro__left{
				position: relative;
				width: 290px;
				float: left;
				padding-top: 353px;
				.dxfy-intro__left_top{
					// width: 650px;
					height: 400px;
					@include abs(-47px, 0);
					// background-color: #0260FE;
					// height:386px;
					.page-section-box{
						left: auto;
						right: 23px;
						top: 23px;
					}
					.dxfy-intro__left_image{
						// @include abs(null, 204px, 0);
						height: 100%;
						width: auto;
					}
				}
				.dxfy-intro__left_box{
					width:190px;
					height:277px;
					border:2px solid rgba(239,239,239,1);
					padding-top: 60px;
				}
				.dxfy-intro__left_bottom{
					padding: 26px 48px 0 0;
					height: 326px;
					.dxfy-intro__left_time{
						font-size: 16px;
						line-height: 18px;
						text-align: right;
						color: #666666;
						
					}
					&:hover{
						.dxfy-intro__left_title{
							color: #0260FC;
						}
					}
					.dxfy-intro__left_title{
						text-align: right;
						padding-right: 26px;
						font-size: 18px;
						line-height: 30px;
						color: #414141;
						margin-top: 30px;
						position: relative;
						cursor: pointer;
						&::after{
							@include abs(13px, 0);
							display: inline-block;
							content: '';
							width: 10px;
							height: 6px;
							background: url(~@/assets/img/index/ai-arrow-down.png) center center / 100% 100% no-repeat;
							transform: rotate(-90deg);
						}
						
					}
					.dxfy-intro__left_desc{
						margin-top: 30px;
						font-size: 14px;
						line-height: 20px;
						color: #777777;
						text-indent: 2em;
					}
					.dxfy-intro__left_btn{
						font-size: 14px;
						color: #0260fe;
						width: 140px;
						height: 37px;
						line-height: 35px;
						background-color: #ffffff;
						border: solid 1px #0260fe;
						// margin-top: 55px;
						text-align: center;
						cursor: pointer;
						@include abs(null, 48px, 0);
					}
				}
			}
			.dxfy-intro__right{
				width: 910px;
				height: 679px;
				display: block;
				margin: 0 auto;
				object-fit: cover;
				object-position: center;
			}
		}
		.train-container{
			margin-top: 55px;
			.train-list{
				margin-top: 25px;
				padding-right: 0;
				display: flex;
				flex-wrap: wrap;
				.train-item{
					margin-right: 1%;
					width: calc(25% - 1%);
					&:nth-of-type(4n){
						margin-right: 0;
					}
				}
			
			}
		}
		.category__title{
			font-size:34px;
			font-weight:bold;
			color:rgba(52,52,52,1);
		}
		.category__enTitle{
			font-size:18px;
			font-weight:400;
			color:rgba(209,209,209,1);
			line-height:19px;
			margin-top: 8px;
			.fr{
				cursor: pointer;
			}
			.fr:hover{
				text-decoration: underline;
				color: #0260fe;
			}
		}
		.activity-container{
			margin-top: 30px;
			border-bottom: 1px solid #E6E6E6;
			.activity-left{
				width: 970px;
				float: left;
			}
			.activity-left__item{
				width: 240px;
				float: left;
			}
			.activity-left-box{
				padding-right: 10px;
				.activity-left__bottom{
					padding: 10px;
					.activity-left__title{
						font-size:16px;
						color:rgba(32,42,48,1);
						@include ellipsis();
					}
					.activity-left__eyes{
						margin-top: 24px;
						.activity-left__eyes_image{
							width: 15px;
							display: inline-block;
							vertical-align: middle;
						}
						.activity-left__eyes_text{
							font-size:16px;
							font-weight:400;
							color: #868686;
							line-height:18px;
							margin-left: 10px;
						}
					}
					.activity-left__text{
						margin-top: 20px;
						font-size:11px;
						font-weight:400;
						color:rgba(32,42,48,1);
					}
					.activity-left__time{
						margin-top: 5px;
						font-size:14px;
						font-weight:bold;
						color:rgba(32,42,48,1);
						line-height:20px;
						//width: 110px;
					}
					.activity-left__btn{
						@include tst();
						margin-top: 36px;
						// background:rgba(255,255,255,1);
						// border:1px solid rgba(185,185,185,1);
						line-height: 48px;
						width: 145px;
						text-align: center;
						height: 52px;
						font-size:22px;
						font-weight:400;
						// color:rgba(185,185,185,1);
						line-height:28px;
						zoom: 0.5;
						cursor: pointer;
					}
				}
				.activity-left__top{
					height:160px;
					width: 100%;
					position: relative;
					.activity-left__top_image{
						display: block;
						width: 100%;
						height: 100%;
					}
					.activity-left__top_mask{
						opacity: 0;
						@include tst();
						@include abs(0, 0, 0, 0);
						background: rgba(2,96,254,0.73) url(~@/assets/img/index/logo.png) center center / 78px auto no-repeat;
					}
				}
				&:hover{
					.activity-left__top_mask{
						opacity: 1;
					}
				}
			}
			.activity-right{
				width: 230px;
				position: relative;
				float: right;
				.activity-right__box{
					height:315px;
					text-align: center;
					position: absolute;
					top: 0;
					left: 0;
					.hdbm-right_image{
						height: 100%;
						width: auto;
					}
					.activity-right__title{
						font-size:37px;
						color:rgba(52,52,52,1);
					}
					.activity-right__enTitle{
						margin-top: 40px;
						font-size:14px;
						font-weight:400;
						color:rgba(52,52,52,1);
					}
				}
				.activity-right__more{
					display: inline-block;
					margin-top: 47px;
					font-size:16px;
					font-weight:400;
					color:rgba(102,102,102,1);
					line-height:36px;
					@include tst();
					cursor: pointer;
					&:hover{
						text-decoration: underline;
						transform: translateX(10px);
					}
				}
			}
		}
		.ad-container{
			margin-top: 20px;
			position: relative;
			display: block;
			height: 120px;
			background: url('~@/assets/img/index/ad.png') center/cover no-repeat;
			color: #fff;
			overflow: hidden;
			.ad-container__content{
				display: flex;
				align-items: center;
				height: 100%;
				padding: 0 40px;
				gap: 30px;
				background: linear-gradient(90deg, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0.35) 45%, rgba(0,0,0,0) 100%);
			}
			.ad-container__text{
				display: flex;
				align-items: center;
				gap: 20px;
				span{
					font-size: 30px;
					font-weight: 700;
				}
			}
			.btn-box{
				background-color: #d60000;
				color: #fff;
				padding: 12px 28px;
				font-size: 16px;
				font-weight: 600;
				line-height: 1;
				border-radius: 2px;
				@include tst();
			}
		}
		.whzx-container{
			height: 595px;
			.whzx-info{
				padding-top: 46px;
				.whzx-item{
					display: block;
					padding: 19px 0;
					border-bottom: 1px solid #D1D1D1;
					cursor: pointer;
					&:last-child{
						border-bottom-width: 0;
					}
					&:hover{
						.whzx-item__title{
							color: #0260FE;
						}
					}
					.whzx-item__right{
						padding-left: 30px;
						width: 535px;
						float: right;
					}
					.whzx-item__title{
						font-size:18px;
						font-weight:400;
						color:rgba(52,52,52,1);
						line-height:36px;
						@include ellipsis();
					}
					.whzx-item__desc{
						font-size:14px;
						font-weight:400;
						color:rgba(120,120,120,1);
						line-height:22px;
						@include ellipsisRow(2);
					}
					.whzx-item__time{
						width:71px;
						height:77px;
						float: left;
						background:rgba(2,96,254,1);
						padding-top: 10px;
						text-align: center;
						color:rgba(255,255,255,1);
						.whzx-item__time_big{
							font-size:30px;
							font-weight:bold;
						}
						.whzx-item__time_small{
							margin-top: 10px;
							font-size:16px;
						}
					}
				}
			}
			.whzx-right{
				padding-left: 40px;
				padding-top: 24px;
				float: right;
				width: 646px;
				.whzx-menu{
					text-align: right;
					.whzx-menu__item{
						line-height: 50px;
						height: 50px;
						display: inline-block;
						margin-left: 30px;
						font-size:18px;
						font-weight:400;
						color:rgba(52,52,52,1);
						cursor: pointer;
						position: relative;
						&::after{
							content: '';
							opacity: 0;
							width: 10px;
							height: 6px;
							@include abs(null, 50%, 0);
							margin-right: -5px;
							background: url(~@/assets/img/index/ai-arrow-down.png) center center / 100% 100% no-repeat;
							transition: all .3s linear;
						}
						&.whzx-menu__item_active,&:hover{
							color: #0260FE;
							&::after{
								opacity: 1;
							}
						}
					}
				}
			}
			.whzx-left{
				width: 554px;
				padding-top: 160px;
				position: relative;
				float: left;
				.whzx-left__bottom{
					.whzx-left__bottom_image{
						display: block;
						width: 100%;
						height: 414px;
						object-fit: cover;
						object-position: center center;
					}
				}
				.whzx-left__top{
					@include abs(-40px, 0, null, 0);
					width: 100%;
					height:200px;
					z-index: 2;
					background:rgba(2,96,254,1);
				}
			}
		}
		
		.page-section-box{
			padding-top: 35px;
			text-align: center;
			@include abs(40px, null, null, 50px);
			width:192px;
			height:157px;
			z-index: 2;
			border:2px solid rgba(239,239,239,1);
		}
		.page-section__title{
			font-size:38px;
			color:rgba(255,255,255,1);
		}
		.page-section__enTitle{
			margin-top: 20px;
			font-size:14px;
			font-weight:400;
			color:rgba(255,255,255,1);
		}
		.page-section__more{
			@include abs(null, 20px, 20px, null);
			font-size:14px;
			font-weight:400;
			cursor: pointer;
			color:rgba(255,255,255,1);
			@include tst();
			&:hover{
				transform: translateX(10px);
				text-decoration: underline;
			}
		}
		.swiper-box {
			width: 100%;
			overflow: hidden;
			.slick-slider{
				margin-bottom: 0;
			}
			.swiper-silde {
				width: 100%;
			}
			.swiper-silde__image {
				width: 100%;
				display: block;
				padding-bottom: 31.25%; /* 600/1920 = 31.25% */
				height: 0;
				background-size: cover;
				background-position: center center;
				background-repeat: no-repeat;
				overflow: hidden;
			}
			.slick-dots{
				//@include abs(93%, 87px, auto, 50%);
        position: absolute;
        bottom: 75px;
        left: 0;
        display: flex;
        justify-content: center;
			}
			.slick-dots li{
				margin: 0;
				width:30px;
				height:30px;
				button{
					width:30px;
					height:30px;
					border-radius:50%;
					margin: 18px auto;
					padding: 0;
					background-color: transparent;
					position: relative;
					opacity: 1;
				}
				button::before{
					@include abs(8px, 8px, auto, auto);
					content: '';
					width: 12px;
					height: 12px;
					background-color:rgba(255,255,255,1);
					border-radius: 50%;
				}
				&.slick-active{
					border-radius: 50%;
					button{
						border:1px solid rgba(255,255,255,1);
					}
				}
			}
		}
		// 资讯飘窗样式
		.pc-popup {
			position: fixed;
			top: 0;
			left: 0;
			z-index: 9999;
			cursor: pointer;
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
			border-radius: 4px;
			overflow: hidden;
			background-color: #fff;
			
			.pc-popup__close {
				position: absolute;
				top: 0;
				right: 0;
				width: 30px;
				height: 30px;
				line-height: 30px;
				text-align: center;
				background-color: rgba(0, 0, 0, 0.5);
				color: #fff;
				font-size: 24px;
				font-weight: bold;
				cursor: pointer;
				z-index: 10;
				transition: background-color 0.3s;
				
				&:hover {
					background-color: rgba(0, 0, 0, 0.7);
				}
			}
			
			.pc-popup__image {
				display: block;
				max-width: 300px;
				width: auto;
				height: auto;
				object-fit: contain;
			}
		}
	}
</style>
